import React from 'react';

import {
	Modal,
	Button,
	Col,
	Row,
	Well
} from 'react-bootstrap';

import PagerUd from '../../../commonComponents/PagerUd';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
import { HrBetweenWell } from '../../../commonComponents/Dividers';
import TitleRow from '../../../commonComponents/TitleRow';
import custJqAjax from '../../../commonJS/custJqAjax';


const
	optsThree = [
		{ value: '1', label: '無權限' },
		// {value: '2', label: '唯讀權限'},
		{ value: '3', label: '完整權限' }
	],
	optsForRepair = [
		{ value: '1', label: '無權限' },
		{ value: '2', label: '唯讀權限' },
		{ value: '3', label: '修改權限' },
		{ value: '4', label: '修改(負責工程師)' },
		{ value: '5', label: '新增/修改' },
		{ value: '6', label: '新增/編輯(負責工程師)' }
	],
	optsForEquipment = [
		{ value: '1', label: '無權限' },
		{ value: '2', label: '唯讀權限' },
		{ value: '3', label: '讀取/修改(建立者)/新增' },
		{ value: '4', label: '讀取/修改(全部)/新增' },
		{ value: '5', label: '讀取/修改(全部)/新增/刪除' }
	],
	optsForOtherReport = [
		{ value: '1', label: '無權限' },
		{ value: '2', label: '只能查自己' },
		{ value: '3', label: '查全部' }
	],
	optsFor31Report = [
		{ value: '1', label: '無權限' },
		// { value: '2', label: '只能查自己' },
		{ value: '3', label: '查全部' }
	],
	optsForTask = [
		{ value: '1', label: '無權限' },
		{ value: '2', label: '自己的任務/他人任務唯讀' },
		{ value: '3', label: '自己的任務' }
	];

const CustDropDownMenu = props => (
	<DropDownMenu
		labelStyle={{
			fontWeight: 'normal',
			color: props.value === '1' ? 'red' : (props.value === '2' ? '#e89702' : 'green')
		}}
		sm={3}
		options={props.opts}
		label={props.label}
		disabled={props.disabled}
		onChange={props.onChange}
		value={props.value}
		stateName={props.stateName} />
);

const CustTitleRow = props => (
	<TitleRow title={props.title} style={props.style}>
		<div className='div-modify-btns-container' style={{ top: -8, right: 15 }}>
			<div>
				<Button className='btn-next-to-title'
					onClick={() => { props.onClick(props.groupName, '3', props.type); }}>
					完整權限
				</Button>
				{/*<Button className='btn-next-to-title'
          onClick={() => {props.onClick(props.groupName, '2', props.type);}}>
          唯讀權限
        </Button>*/}
				<Button className='btn-next-to-title'
					onClick={() => { props.onClick(props.groupName, '1', props.type); }}>
					無權限
				</Button>
			</div>
		</div>
	</TitleRow>
);


export default class UserPermissionModalCt extends React.Component {
	constructor(props) {
		super(props);
		this.handlers = {
			onSwtichPermissionsClick: (groupName, permissionToApply, type) => {
				const userPermissions = this.state.userPermissions.slice();

				switch (groupName) {
					case 'all':
						userPermissions.forEach((item, ind) => {
							item.permission = permissionToApply;
							// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
							if (permissionToApply === '3') {
								switch (item.front_name) {
									case 'servicesky_repair_web':
									case 'servicesky_repair':
									case 'salesky_repair_web':
									case 'salesky_repair':
									case 'salesky_equipment':
										item.permission = '5'
										break;
									default:

								}
							}
							// ===
						});
						break;
					case 'web':
						userPermissions.forEach((item, ind) => {
							if (item.front_name.indexOf('_web') !== -1) {
								item.permission = permissionToApply
								// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
								if (permissionToApply === '3') {
									switch (item.front_name) {
										case 'servicesky_repair_web':
										case 'salesky_repair_web':
											item.permission = '5'
											break;
										default:

									}
								}
								// ===
							}
						});
						break;
					case 'app':
						userPermissions.forEach((item, ind) => {
							if (item.front_name.indexOf('_web') === -1) {
								item.permission = permissionToApply
								// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
								if (permissionToApply === '3') {
									switch (item.front_name) {
										case 'servicesky_repair':
										case 'salesky_repair':
										case 'salesky_equipment':
											item.permission = '5'
											break;
										default:

									}
								}
								// ===
							}
						});
						break;
					case 'salesky':
					case 'servicesky':
					case 'agentsky':
						if (type) {
							switch (type) {
								case 'web':
									userPermissions.forEach((item, ind) => {
										if (item.product_code === groupName && item.front_name.indexOf('_web') !== -1) {
											item.permission = permissionToApply
											// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
											if (permissionToApply === '3') {
												switch (item.front_name) {
													case 'servicesky_repair_web':
													case 'salesky_repair_web':
														item.permission = '5'
														break;
													default:

												}
											}
											// ===
										}
									});
									break;
								case 'app':
									userPermissions.forEach((item, ind) => {
										if (item.product_code === groupName && item.front_name.indexOf('_web') === -1) {
											item.permission = permissionToApply
											// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
											if (permissionToApply === '3') {
												switch (item.front_name) {
													case 'servicesky_repair':
													case 'salesky_repair':
													case 'salesky_equipment':
														item.permission = '5'
														break;
													default:

												}
											}
											// ===
										}
									});
									break;

								default:
							};
						} else {
							userPermissions.forEach((item, ind) => {
								if (item.product_code === groupName) {
									item.permission = permissionToApply
									// 暫時只對特定項目套用5階權限控制，先簡單處理 ===
									if (permissionToApply === '3') {
										switch (item.front_name) {
											case 'servicesky_repair_web':
											case 'servicesky_repair':
											case 'salesky_repair_web':
											case 'salesky_repair':
											case 'salesky_equipment':
												item.permission = '5'
												break;
											default:

										}
									}
									// ===
								}
							});
						}
						break;

					default:
				};

				this.setState({ userPermissions, btnSaveDisable: false });
			},
			dropDownOnChange: (selection, stateName) => {
				const userPermissions = this.state.userPermissions.slice();
				userPermissions[stateName].permission = selection.value;
				this.setState({ userPermissions, btnSaveDisable: false });
			},
			// onInputFocus: e => {
			//   autoFill(e, this);
			// },
			saveItem: () => {
				this.setState({ onSaving: true });

				const state = this.state,
					props = this.props,
					id = props.filteredSortedData.getObjectAt(props.selectedRowIndex).user_id;

				let permissionListString = '',
					formData = new FormData();

				state.userPermissions.forEach((item, ind) => {
					permissionListString += item.front_name + ',' + item.permission + '|';
				});

				formData.append('user_id', id);
				formData.append('front_name_permission_list', permissionListString);

				custJqAjax({
					type: 'POST',
					url: '/api/W_SkyFamily_User_Front_Permission_Update.php',
					data: formData,
					processData: false,
					contentType: false,
					success: res => {
						if (res.status !== '0') return;

						this.setState({ btnSaveDisable: true, onSaving: false });

						// 原本儲存完不關閉，暫時改關閉
						this.props.closeModal();
					}
				});
			},
			loadItemData: () => {

				const id = this.props.filteredSortedData.getObjectAt(this.props.selectedRowIndex).user_id;

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: `/api/W_SkyFamily_User_Front_Permission_Get.php?user_id=${id}`,
					processData: false,
					contentType: false,
					success: res => {
						if (res.status !== '0') return;
						const data = res.result;

						// presorting
						data.sort((a, b) => (a.front_name_key - b.front_name_key));

						this.setState({
							userPermissions: data
						});

					}
				});

			},
			rowIndexCheck: passUpdate => {
				// 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
				// if( this.props.params &&
				//     this.props.params.itemId &&
				//     !this.props.selectedRowIndex &&
				//     this.props.selectedRowIndex !== 0 ) {

				//       // 初始狀態的ind和indexMap是一樣的
				//   let itemId = this.props.params.itemId,
				//       ind = findIndex(this.props.filteredSortedData._data, {delivery_number: itemId});

				//   if(!passUpdate) {
				//     this.props.parentStateHandler({
				//       states: ['selectedItemId', 'selectedRowIndex'],
				//       newValues: [itemId, ind] 
				//     });
				//   }

				//   return ind;
				// }
				return this.props.selectedRowIndex;
			},
			changeItem: () => {
				this.handlers.loadItemData();
			},
			onPreviousClick: () => {
				let selectedRowIndex = this.handlers.rowIndexCheck(),
					r = (selectedRowIndex - 1),
					rowIndex = r >= 0 ? r : 0;
				if (rowIndex !== selectedRowIndex) {
					this.props.onRowClick('e', rowIndex, this.props.filteredSortedData, 1);

					// load new item
					this.funcs.resetState(this.handlers.changeItem);
				}
			},
			onNextClick: () => {
				let selectedRowIndex = this.handlers.rowIndexCheck(),
					r = (selectedRowIndex + 1),
					filteredSortedData = this.props.filteredSortedData,
					max = filteredSortedData.getSize(),
					rowIndex = r < max ? r : (max - 1);
				if (rowIndex !== selectedRowIndex) {
					this.props.onRowClick('e', rowIndex, filteredSortedData, 1);

					// load new item
					this.funcs.resetState(this.handlers.changeItem);
				}
			}
		};

		this.funcs = {
			resetState: cb => {
				this.setState({
					// item ===
					// 避免畫面一閃，保留資料維持架構
					// userPermissions: [],
					// ===
					// common
					btnSaveDisable: true,
					onSaving: false
				}, cb ? cb : '');
			},
			permissionGroupFilter: (editable) => {
				// 先過濾群組，避免多餘loop
				const languageData = this.props.languageData;
				let saleSkyWebGroupContent = [],
					serviceSkyWebGroupContent = [],
					agentSkyWebGroupContent = [],
					saleSkyAppGroupContent = [],
					serviceSkyAppGroupContent = [],
					agentSkyAppGroupContent = [];

				this.state.userPermissions.forEach((item, ind) => {
					const label =
						languageData[item.front_name_key]
							? languageData[item.front_name_key]['zh-tw']
							: '名稱錯誤',
						opts =
							(
								item.front_name === 'servicesky_repair' ||
								item.front_name === 'servicesky_repair_web' ||
								item.front_name === 'salesky_repair' ||
								item.front_name === 'salesky_repair_web'
							)
								? optsForRepair
								: item.front_name === 'salesky_equipment'
									? optsForEquipment
									:
									(
										item.front_name === 'salesky_report_product_history' ||
										item.front_name === 'salesky_report_unpaid' ||
										item.front_name === 'salesky_report_receivable' ||
										item.front_name === 'salesky_report_accounts_receivable'
									)
										? optsForOtherReport
										:
										(
											item.front_name === 'salesky_31_report' ||
											item.front_name === 'salesky_report_purchase'
										)
											? optsFor31Report
											: item.front_name === 'salesky_task'
												? optsForTask
												: optsThree,
						permission = (
							<CustDropDownMenu
								key={ind}
								label={label}
								opts={opts}
								disabled={!editable}
								onChange={this.handlers.dropDownOnChange}
								value={item.permission}
								stateName={ind} />
						);

					switch (item.product_code) {
						case 'salesky':
							if (item.front_name.indexOf('_web') !== -1) {
								saleSkyWebGroupContent.push(permission);
							} else {
								saleSkyAppGroupContent.push(permission);
							}

							break;
						case 'servicesky':
							if (item.front_name.indexOf('_web') !== -1) {
								serviceSkyWebGroupContent.push(permission);
							} else {
								serviceSkyAppGroupContent.push(permission);
							}
							break;
						case 'agentsky':
							if (item.front_name.indexOf('_web') !== -1) {
								agentSkyWebGroupContent.push(permission);
							} else {
								agentSkyAppGroupContent.push(permission);
							}
							break;

						default:
					};
				});

				return {
					saleSkyWebGroupContent,
					serviceSkyWebGroupContent,
					agentSkyWebGroupContent,
					saleSkyAppGroupContent,
					serviceSkyAppGroupContent,
					agentSkyAppGroupContent
				};
			}
		};

		this.ajaxsWip = [];

		// setTimeout Id
		this.timer = '';

		this.state = {
			// item ===
			userPermissions: [],
			// ===
			// common
			btnSaveDisable: true,
			onSaving: false
		};
	}


	componentDidMount() {
		this.handlers.loadItemData();
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
		clearTimeout(this.timer);
	}

	render() {
		const props = this.props,
			state = this.state,
			handlers = this.handlers,
			editable = true;

		const saveBtn = (
			<Button disabled={state.btnSaveDisable}
				onClick={() => { handlers.saveItem(state.onEdit ? 1 : 0) }}
				style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
				儲存{state.onSaving ? '中…' : ''}
			</Button>
		);

		let disablePreviousBtn = false,
			disableNextBtn = false;

		if (props.filteredSortedData.getSize) {
			const selectedRowIndex = handlers.rowIndexCheck(true),
				max = props.filteredSortedData.getSize();

			disablePreviousBtn = (selectedRowIndex === 0);
			disableNextBtn = (selectedRowIndex === (max - 1));
		}

		const pagerUd = <PagerUd style={{ position: 'absolute', width: '100%', top: 15, marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: '1px 0' }}
			onPreviousClick={handlers.onPreviousClick}
			onNextClick={handlers.onNextClick}
			disablePreviousBtn={disablePreviousBtn}
			disableNextBtn={disableNextBtn} />;

		const {
			saleSkyWebGroupContent,
			// serviceSkyWebGroupContent,
			// agentSkyWebGroupContent,
			saleSkyAppGroupContent,
			// serviceSkyAppGroupContent,
			// agentSkyAppGroupContent
		} = this.funcs.permissionGroupFilter(editable);

		return (
			<Modal id='modal-product-spec' keyboard={false} backdrop='static' show={true} onHide={props.closeModal} bsSize='large'>
				<Modal.Header>
					<Modal.Title>
						<span style={{ padding: '6px 0px', height: 34, lineHeight: '34px' }}>
							<span>
								權限設定
							</span>
						</span>
						<Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>關閉</Button>
						{saveBtn}
						{pagerUd}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<div style={{ marginTop: 5 }}>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={12}>
										<div style={{ fontWeight: 'bold', position: 'relative', marginBottom: 20 }}>
											<span style={{ color: 'blue' }}>{props.selectedItemId}</span>
										</div>
									</Col>
								</Row>

								<Row>
									<Col sm={12}>
										<div style={{ fontWeight: 'bold', position: 'relative', marginBottom: 20 }}>
											<span>全部</span>
											<div className='div-modify-btns-container' style={{ top: -4 }}>
												<div>
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('all', '3'); }}>
														完整權限
													</Button>
													{/*<Button className='btn-next-to-title'
                            onClick={() => {handlers.onSwtichPermissionsClick('all', '2');}}>
                            唯讀權限
                          </Button>*/}
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('all', '1'); }}>
														無權限
													</Button>
												</div>
											</div>
										</div>
									</Col>
								</Row>

								<Row>
									<Col sm={12}>
										<div style={{ fontWeight: 'bold', position: 'relative', marginBottom: 20 }}>
											<span>Web</span>
											<div className='div-modify-btns-container' style={{ top: -4 }}>
												<div>
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('web', '3'); }}>
														完整權限
													</Button>
													{/*<Button className='btn-next-to-title'
                            onClick={() => {handlers.onSwtichPermissionsClick('web', '2');}}>
                            唯讀權限
                          </Button>*/}
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('web', '1'); }}>
														無權限
													</Button>
												</div>
											</div>
										</div>
									</Col>
								</Row>

								<Row>
									<Col sm={12}>
										<div style={{ fontWeight: 'bold', position: 'relative', marginBottom: 20 }}>
											<span>App</span>
											<div className='div-modify-btns-container' style={{ top: -4 }}>
												<div>
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('app', '3'); }}>
														完整權限
													</Button>
													{/*<Button className='btn-next-to-title'
                            onClick={() => {handlers.onSwtichPermissionsClick('app', '2');}}>
                            唯讀權限
                          </Button>*/}
													<Button className='btn-next-to-title'
														onClick={() => { handlers.onSwtichPermissionsClick('app', '1'); }}>
														無權限
													</Button>
												</div>
											</div>
										</div>
									</Col>
								</Row>

							</Col>

						</Row>

						<HrBetweenWell style={{ marginBottom: 25 }} />

						<CustTitleRow
							title='J&H'
							groupName='salesky'
							onClick={handlers.onSwtichPermissionsClick} />

						<Well style={{ marginBottom: 15 }}>

							<CustTitleRow
								title='Web'
								groupName='salesky'
								type='web'
								onClick={handlers.onSwtichPermissionsClick} />

							<Well style={{ marginBottom: 0 }}>
								<Row>
									{saleSkyWebGroupContent}
								</Row>
							</Well>

							<CustTitleRow
								style={{ marginTop: 20 }}
								title='App'
								groupName='salesky'
								type='app'
								onClick={handlers.onSwtichPermissionsClick} />

							<Well style={{ marginBottom: 0 }}>
								<Row>
									{saleSkyAppGroupContent}
								</Row>
							</Well>

						</Well>

						{/* <HrBetweenWell style={{ marginBottom: 25 }} />

            <CustTitleRow
              title='ServiceSky'
              groupName='servicesky'
              onClick={handlers.onSwtichPermissionsClick} />

            <Well style={{ marginBottom: 15 }}>

              <CustTitleRow
                title='Web'
                groupName='servicesky'
                type='web'
                onClick={handlers.onSwtichPermissionsClick} />

              <Well style={{ marginBottom: 0 }}>
                <Row>
                  {serviceSkyWebGroupContent}
                </Row>
              </Well>

              <CustTitleRow
                style={{ marginTop: 20 }}
                title='App'
                groupName='servicesky'
                type='app'
                onClick={handlers.onSwtichPermissionsClick} />

              <Well style={{ marginBottom: 0 }}>
                <Row>
                  {serviceSkyAppGroupContent}
                </Row>
              </Well>

            </Well>

            <HrBetweenWell style={{ marginBottom: 25 }} />

            <CustTitleRow
              title='AgentSky'
              groupName='agentsky'
              onClick={handlers.onSwtichPermissionsClick} />

            <Well style={{ marginBottom: 15 }}>
              <CustTitleRow
                title='Web'
                groupName='agentsky'
                type='web'
                onClick={handlers.onSwtichPermissionsClick} />

              <Well style={{ marginBottom: 0 }}>
                <Row>
                  {agentSkyWebGroupContent}
                </Row>
              </Well>


              <CustTitleRow
                style={{ marginTop: 20 }}
                title='App'
                groupName='agentsky'
                type='app'
                onClick={handlers.onSwtichPermissionsClick} />

              <Well style={{ marginBottom: 0 }}>
                <Row>
                  {agentSkyAppGroupContent}
                </Row>
              </Well>
            </Well> */}
					</div>
				</Modal.Body>
				<Modal.Footer>
					{pagerUd}
					<Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>關閉</Button>
					{saveBtn}
				</Modal.Footer>
			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/UserPermissionModalCt.jsx